// extracted by mini-css-extract-plugin
export default {"nav_link":"index_nav_link_qReNZ"};